export const getBlackmailAmount = (playerCurrentWorth: number) => {
  return Math.round(Math.min(25000, Math.max(500, playerCurrentWorth / 20)));
};
